import React from "react";

export default class ChevronRightSVG16x16 extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.6665 4L10.6665 8L6.6665 12" />
      </svg>
    );
  }
}
